import { lazy } from 'react';
import { RouteItem } from '@elsa-zku/lib/components/App/components/Content';

const routes: RouteItem[] = [
  {
    path:      'buildings',
    name:      'buildings',
    component: () => import('src/routes/Buildings'),
  },
  {
    path:      '/buildings/add',
    name:      'buildingAdd',
    component: () => import('src/routes/BuildingForm'),
  },
  {
    path:      '/buildings/:id',
    name:      'buildingEdit',
    component: () => import('src/routes/BuildingForm'),
  },
  {
    path:      '/apartments',
    name:      'apartments',
    component: () => import('src/routes/Apartments'),
  },
  {
    path:      '/apartments/add',
    name:      'apartmentsAdd',
    component: () => import('src/routes/ApartmentsAdd'),
  },
  {
    path:      '/apartments/:id',
    name:      'apartment',
    component: () => import('src/routes/Apartment'),
  },
  {
    path:      '/devices',
    name:      'devices',
    component: () => import('src/routes/Devices'),
  },
  {
    path:      '/values-import',
    name:      'valuesImport',
    component: () => import('src/routes/ValuesImport'),
  },
  {
    path:      '/calculations',
    name:      'calculations',
    component: () => import('src/routes/Calculations'),
  },
  {
    path:      '/calculations/add',
    name:      'calculationAdd',
    component: () => import('src/routes/CalculationAdd'),
  },
  {
    path:      '/calculations/:id',
    name:      'calculation',
    component: () => import('src/routes/Calculation'),
  },
  {
    path:      '/final-calculations',
    name:      'final-calculations',
    component: () => import('src/routes/FinalCalculations'),
  },
  {
    path:      '/final-calculations/add',
    name:      'final-calculations-add',
    component: () => import('src/routes/FinalCalculationsAdd'),
  },
  {
    path:      '/final-calculations/:id',
    name:      'final-calculation',
    component: () => import('src/routes/FinalCalculation'),
  },
  {
    path:      '/xml-import',
    name:      'xml-import',
    component: () => import('src/routes/XmlImport'),
  },
  {
    path:      '/xml-import/:id',
    name:      'xml-import-info',
    component: () => import('src/routes/XmlImportInfo'),
  },
  {
    path:      '/corrections',
    name:      'corrections',
    component: () => import('src/routes/Corrections'),
  },
  {
    path:      '/corrections/add',
    name:      'corrections-add',
    component: () => import('src/routes/CorrectionAdd'),
  },
  {
    path:      '/cities',
    name:      'cities',
    component: () => import('src/routes/Cities'),
  },
  {
    path:      '*',
    name:      'notFound',
    component: () => import('@elsa-zku/lib/components/NotFoundRoute'),
  },
];

export default routes;
